import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from "react-i18next";

import { Form, Input, Col } from 'antd';
const { TextArea } = Input;

function TextareaField({
  data,
  index,
  rows,
  // default
  className
}) {
  const childClassNames = classNames('custom-form-column', 'textarea-input-column', className);
  const { t } = useTranslation();

  return data && (
    <Col
      key={data?.name + index + '-col'}
      md={data?.col || 24}
      xs={24}
      offset={data?.offset || null}
      className={childClassNames}
    >
      <Form.Item
        key={data?.name + index + '-item'}
        label={data?.displayLabel ? data?.label : data?.label}
        name={data?.name}
        className={data?.name + '-wrapper textarea-input'}
        initialValue={data?.value}
        rules={[
          {
            required: data?.required || false,
            message: t("inputs.mandatoryField"),
            validateTrigger: 'onSubmit',
          },
        ]}
      >
        <TextArea placeholder={data.placeholder || ''} rows={rows} />
      </Form.Item>
    </Col>
  );
};

TextareaField.defaultProps = {
  index: 1,
  rows: 4
};

TextareaField.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.bool.isRequired,
    PropTypes.object.isRequired,
  ]),
};

export default memo(TextareaField);